// KeteranganDivider.jsx
const KeteranganDivider = ({ 
    text = "KETERANGAN", 
    lineColor = "border-gray-300", 
    textStyle = "font-bold text-gray-700" 
  }) => (
    <div className="flex items-center my-6">
      <span className={`pr-3 whitespace-nowrap ${textStyle}`}>
        {text}
      </span>
      <div className={`flex-grow border-t ${lineColor}`} />
    </div>
  );
  export default KeteranganDivider;